import React, { useState, useEffect } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from 'olive-react-myoneui/lib/Button';
import Card from 'olive-react-myoneui/lib/Card';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Badge from 'olive-react-myoneui/lib/Badge';
import Form from 'olive-react-myoneui/lib/Form';
import { Buffer } from 'buffer';
import { eventTransfer, eventTransferOrder} from '../../../../api/afterLogin/events';
import { Cookies } from "react-cookie-consent";
import { TransferEventLoader } from '../../Loader';
import ModalCommon from '../ModalCommon';
import Toast from 'olive-react-myoneui/lib/Toast';
import ToastInfo from 'olive-react-myoneui/lib/ToastInfo';

import { transferIcon, refundIcon, calendarIcon101, broadcastIcon, videoRecordIcon, rightArrowLong, geoMarkIcon } from '../../../constants/icons';

const TransferOrders = ({className}) => {
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('primary');
    
    const [errorMessage, setErrorMessage] = useState('');
    const { hashId } = useParams();
    const userData   = useSelector((state) => state.user.user.logged_in_user.user);
    const configData = useSelector((state) => state.config);
    const paths = useSelector((state) => state.user.paths);
    const navigate = useNavigate();
    
    const [eventDetails, setEventDetails] = useState([]);
    const [paymentDetails, setPaymentDetails] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showModalTransfer, setShowModalTransfer] = useState(false);
    const [showUnselectEvent, setShowUnselectEvent] = useState(false);

    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isMemberPrice, setIsMemberPrice] = useState(null);
    const [isTncChecked, setIsTncChecked] = useState(false);
    const [proceeding, setProceeding] = useState(false);
    const [notFound, setnotFound] = useState(false);

    const handleEventSelect = (eventId, isMemberPrice) => {
        setSelectedEvent(eventId);
        setIsMemberPrice(isMemberPrice);
    };

    const handleTncChange = (event) => {
        setIsTncChecked(event.target.checked);
    };

    const handleModal = () => {
        if (selectedEvent === null) {
            setShowUnselectEvent(true);
        } else {
            setShowModalTransfer(true);
        }
    };

    const closeModel = () => {
        setShowUnselectEvent(false);
        setShowModalTransfer(false);
    }

    const handleTransfer = async () => {
        setShowModalTransfer(false);
        setProceeding(true);
        const postParams = {
            selectedEvent: selectedEvent,
            isMemberPrice: isMemberPrice,
            eventId: atob(hashId),
            user: userData.id,
            email: userData.us_email,
            name: userData.us_name,
            phone: userData.us_phone,
            role: userData.us_role_id,
        }
        try {
            let url = '';
            const response = await eventTransferOrder(configData?.access_token, postParams);
            if (response) {
                const paymentId   = response?.data?.payment_id;
                const paymentLink = response?.data?.payment_link
                if (paymentId && paymentLink) {

                    postParams.redirect       = window.location.origin + '/student-dashboard/transfer/success';
                    postParams.failedRedirect = window.location.origin + '/student-dashboard/transfer/failed';
                    const cookieParam         = { ...postParams, ...response?.data?.payment_session_detail }
                    
                    const encodedData         = Buffer.from(JSON.stringify(cookieParam)).toString('base64');

                    const isProduction = window.location.protocol === 'https:';
                    /* STORE PAYMENT ID AND EVENT ID IN COOKIE */
                    Cookies.set(`SPSTRANSFER_${atob(hashId)}`, encodedData, {
                        expires: 1 / 24,
                        secure: isProduction,
                        sameSite: 'Lax',
                        path: '/',
                    });
                    url = window.location.origin + '/checkout/payment_request/' + Buffer.from(String(paymentId)).toString('base64');
                } else {
                    url = window.location.origin + '/student-dashboard/transfer/success';
                }
                window.location.href = url;
            } else {
                setToastMessage('Error transferring the event. Please, try again.');
                setToastVariant('error')
                setShowToast(true);
                setProceeding(false);
            }
        } catch (error) {
            setToastMessage('Error transferring the event. Please, try again.');
            setToastVariant('error')
            setShowToast(true);
            setProceeding(false);
            console.error(error);
        }
    }

    const handleBack = () => {
        navigate('/student-dashboard');
    };

    const getEvents = async (eventId) => {
        try {
            const postParams = {
                eventId: eventId,
                userId: userData.id,
                email: userData.us_email,
            }
            const fetchEvent = await eventTransfer(configData?.access_token, postParams);
            if (fetchEvent) {
                setEventDetails(fetchEvent.data.event_details);
                setPaymentDetails(fetchEvent.data.payment_details);
                setAllEvents(fetchEvent.data.all_events);
                setnotFound(false);
            } else {
                setnotFound(true);
            }
            setIsLoading(false);
            
        } catch (error) {
            setnotFound(true);
            setIsLoading(false);
            console.error(error);
        }
    };

    const eventData = {
        id: atob(hashId),
        title: eventDetails?.bce_name,
        image: eventDetails?.bce_thumbnail !== '' ? paths.event_path + eventDetails?.bce_thumbnail : paths.default_event,
        price: paymentDetails?.currency_symbol + paymentDetails?.credit_amt,
        date: eventDetails?.event_datetime,
        transferDeadline: eventDetails?.transfer_enabled > 0 ? eventDetails?.transfer_date_format : '-',
        refundDeadline: eventDetails?.refund_enabled > 0 ? eventDetails?.refund_date : '',
        transferAvailable: eventDetails?.transfer_set === 1 ? true : false
    }
    const online  = { type: 'Live Online', icon: broadcastIcon }
    const offline = { type: 'Offline', icon: videoRecordIcon }
    const allEventsData = allEvents && allEvents.map((event) => {
        return {
            id: event?.id,
            date: event?.bce_startdate_formatted,
            time: event?.bce_event_start_formatted + ' - ' + event?.bce_event_end_formatted,
            sessionType: event?.bce_delivered_type === 'venue' ? offline : online,
            price: paymentDetails?.currency_symbol + (event?.is_member_price === 0 ? event?.bce_price : event?.bce_member_price),
            badge: { label: (event?.is_member_price > 0 ? event.member_price_label : event.current_pricing_label), variant: 'info' },
            address: event?.bce_delivered_type === 'venue' ? event?.bce_venue + ', ' + event?.bce_venue_location : '',
            is_member_price: event?.is_member_price
        }
    })
    const eventsAvailable = allEventsData ? true : false;
    
    useEffect(() => {
        if (hashId && hashId?.length % 4 === 0) {
            const convertedHashId = atob(hashId) ?? 0;
            if (convertedHashId) {
                getEvents(atob(hashId));
                return;
            }
        }
        setnotFound(true);
        setIsLoading(false);
    }, [hashId])
    
    return (
        <>
        <div className={`${className || ''} myk__stu-transfer-orders-container py-5`}>
            {isLoading === false && notFound === false ? (
            <Card className="myk__stu-transfer-orders border-0">
                <Card.Header>
                    <div className="myk_stu-page-header mb-0">
                        <h2>Transfer Order</h2>
                    </div>
                </Card.Header>
                <Card.Body>
                {eventDetails && eventData && (
                    <div className="myk__stu-order-item" key={eventData.id}>
                        <Row className="align-items-start">
                            <Col sm={5} lg={5} xl={3} className="mb-3 mb-xl-0">
                            {eventDetails && eventData.image ? (
                            <Card.Img
                                src={eventData.image}
                                className="rounded w-100 course-image"
                                alt="Event Image"
                            />
                            ) : (
                            <Card.Img
                                src={paths.default_event}
                                className="rounded w-100 course-image"
                                alt="Event Image"
                            />  
                            )}
                            </Col>
                            <Col sm={7} lg={7} xl={9} className="card-info">
                            {eventData.title ? (
                            <h3>
                                <span className="myk__stu-order-title">{eventData.title}</span>
                                <span className="myk__stu-order-price">{eventData.price}</span>
                            </h3>
                            ) : (
                            <h3><span className="myk__stu-order-title">{'Event Available'}</span></h3>
                            )}
                            {eventData.date && (
                            <p>
                                {calendarIcon101} <span>{eventData.date}</span>
                            </p>
                            )}
                            {eventData && eventData.transferDeadline ? (
                            <p>
                                {transferIcon}{" "}
                                <span>Transfer available: Until {eventData.transferDeadline}</span>
                            </p>
                            ) : (
                                <p>
                                    {transferIcon}{" "}
                                    <span>Transfer not available</span>
                                </p> 
                            )}
                            {eventData && eventData.refundDeadline ? 
                            (<p>
                                {refundIcon}{" "}
                                <span>Refund available: Until {eventData.refundDeadline}</span>
                            </p>) :
                            (<p>
                                {refundIcon}{" "}
                                <span>Refund not available</span>
                            </p>)
                            }
                            {!eventData.transferAvailable && 
                                <Button
                                    variant="orange"
                                    className="bg-orange-fade bg-orange mt-2 me-2 btn-sm"
                                    disabled="disabled"
                                >
                                    Transfer Unavailable
                                </Button>
                            }
                            </Col>
                        </Row>
                    </div>
                )}
                </Card.Body>
                <span className="card-divider my-1 mx-3" />
                <Toast className="mt-2 mx-3" variant={toastVariant} show={showToast} onClose={() => setShowToast(false)}>
                    <Toast.Body>
                        <ToastInfo toastDescription={toastMessage} />
                        <div className="action-wrapper">
                        <Button
                        variant="orange"
                        type="button"
                        size="sm"
                        className="btn-round bg-orange-fade"
                        aria-label="Close"
                        onClick={() => setShowToast(false)}
                        >
                        Close
                        </Button>
                    </div>
                    </Toast.Body>
                </Toast>
                <Card.Footer className="d-block w-100">
                    {eventsAvailable && (
                    <div className="myk_stu-page-header mb-2">
                        <h2>Transfer To</h2>
                    </div>
                    )}
                    {!eventsAvailable ? (
                        <div className="myk__stu-order-transfer_recipient myk__stu-order-transfer_unavailable">
                        <p>Sorry, we're unable to transfer you as there is no other event available or the seats are filled up.</p>
                        </div>
                    ) : (
                        <div className="myk__stu-transferable_events">
                        {allEventsData && allEventsData.map((event) => (
                            <div key={event.id} className={`myk__stu-transferable_event-item_wrapper ${selectedEvent === event.id ? "selected" : ""}`}
                                >
                                <Form.Check>
                                    <Form.Check.Input
                                    type="radio"
                                    name="myk__stu-event-radio"
                                    id={`myk__stu-event-radio-${event.id}`}
                                    onChange={() => handleEventSelect(event.id, event.is_member_price)}
                                    disabled={eventData.transferAvailable === true ? false : true}
                                    />
                                    <Form.Check.Label htmlFor={`myk__stu-event-radio-${event.id}`}>
                                        <div className="myk__stu-transferable_event-item">   
                                            <div className="myk__stu-event-dates">
                                                <h4>{event.date}</h4>
                                                <p>{calendarIcon101} {event.time}</p>
                                                {event.address !== '' ?  (<p>{geoMarkIcon} {event.address}</p>) : ('')} 
                                            </div>
                                            <div className={`myk__stu-event-session-type ${event.sessionType.type.toLowerCase().replace(' ', '-')}`}>
                                                <span>{event.sessionType?.icon}</span>
                                                <span>{event.sessionType?.type}</span>
                                            </div>
                                            <div className="myk__stu-event-price-type">
                                                <strong>{event.price}</strong>
                                                <Badge bg={event?.badge?.variant}>{event?.badge?.label || "Standard"}</Badge>
                                            </div>
                                        </div>
                                    </Form.Check.Label>
                                </Form.Check>
                            </div>
                        ))}
                        </div>
                    )}
                    {eventData.transferAvailable && (
                    <Row className="mt-4">
                        <Col sm={8} lg={7} xl={9} className="myk__stu-event-tnc">
                            <Form.Check>
                                <Form.Check.Input type="checkbox" id="tnc_transfer" onChange={handleTncChange}/>
                                <Form.Check.Label for="tnc_transfer">
                                    Click here to agree the <a href={`${window.location.origin}/terms-and-conditions`} target="_blank"><strong>Terms and Conditions</strong></a> and proceed the transfer. 
                                    <span className="help-text">
                                    You'll only be able to transfer selected event in you agree the{' '}
                                    <strong>Terms and Conditions.</strong>
                                    </span>
                                </Form.Check.Label>
                            </Form.Check>
                        </Col>
                        <Col sm={4} lg={5} xl={3} className="myk__stu-event-tnc text-end mt-3 mt-xl-0">
                            {proceeding === false ?
                            (<Button variant="primary" className="d-inline-flex align-items gap-1" disabled={!isTncChecked} onClick={handleModal}>Transfer Event {rightArrowLong}</Button>) :
                            (<Button variant="primary" className="text-center btn-loading-txt" type="button" disabled>
                                <span className="label">Add</span>
                                <span className="btn-loader">
                                    <span
                                    className="spinner-border spinner-border-vsm"
                                    role="status"
                                    aria-hidden="true"
                                    />
                                    <span>Proceeding...</span>
                                </span>
                            </Button>)
                            }
                        </Col>
                    </Row>
                    )}
                    {!eventsAvailable || !eventDetails && (
                    <Row className="mt-4">
                        <Col sm={4} lg={5} xl={3} className="myk__stu-event-tnc text-end mt-3 mt-xl-0">
                            <Button variant="primary" className="d-inline-flex align-items gap-1" onClick={handleBack}>Back To Dashboard</Button>
                        </Col>
                    </Row>
                    )}
                </Card.Footer>
            </Card>
            ) : (isLoading === false && notFound) ? (
            <Card className="myk__stu-transfer-orders border-0">
                <Card.Header>
                    <div className="myk_stu-page-header mb-0">
                        <h2>Event not available</h2>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="myk__stu-order-item" key={eventData.id}>
                        <Row className="align-items-start">
                            <Col sm={12} lg={12} xl={12} className="card-info">
                                <h4>Oops ! Something weng wrong.</h4>
                                <p className='text-center'>Sorry, event not available or you have not enrolled to event.</p>
                            </Col>
                        </Row>
                    </div>
                </Card.Body>
                <span className="card-divider my-1 mx-3" />
                <Card.Footer className="d-block w-100">
                    <Row className="mt-4">
                        <Col sm={4} lg={5} xl={3} className="myk__stu-event-tnc text-end mt-3 mt-xl-0">
                            <Button variant="primary" className="d-inline-flex align-items gap-1" onClick={handleBack}>Back To Dashboard</Button>
                        </Col>
                    </Row>
                </Card.Footer>
            </Card>
            ) : (
            <TransferEventLoader />
            )}
        </div>

        <ModalCommon
            show={showUnselectEvent}
            onClose={closeModel}
            title="Please select an event to transfer !!"
            className="myk__stu-question-modal"
        >
            <div className="text-start">
            <Row>
                <Col className="myk__stu-min-content">
                    <p>No Event Selected.</p>
                    <p>Oops! Please select at least one event to proceed.</p>
                </Col>
            </Row>               
            <Row>
                <Col className="text-end mt-3">
                    <Button variant="primary" onClick={closeModel}>Ok</Button>
                </Col>
            </Row>
            </div>
        </ModalCommon>

        <ModalCommon
            show={showModalTransfer}
            onClose={closeModel}
            title="Are you sure you want to transfer the event?"
            className="myk__stu-question-modal"
        >
            <div className="text-start">
            <Row>
                <Col className="myk__stu-min-content">
                    <p>Your event will be transferred to the selected date.</p>
                    <p>Once transferred cannot be undone again.</p>
                </Col>
            </Row>               
            <Row>
                <Col className="text-end mt-3">
                    <Button variant="default" onClick={closeModel}>Cancel</Button>
                    <Button variant="primary" onClick={handleTransfer}>Confirm Transfer</Button>
                </Col>
            </Row>
            </div>
        </ModalCommon>
        </>  
    )
    
}

export default TransferOrders;